import { Link, useParams } from 'react-router-dom';

import arrowLeftSide from "../../assets/images/icons/arrow-leftside.svg";
import notification from "../../assets/images/icons/notification-bing.svg";
import shop from "../../assets/images/icons/shop.svg";
import send from "../../assets/images/icons/send.svg";
import home from "../../assets/images/icons/home-hashtag.svg";
import calculator from "../../assets/images/icons/calculator.svg";
import document from "../../assets/images/icons/document.svg";
import apiMethod from '../../services/api-service';
import methods from '../../services/utility';
import { useEffect, useState } from 'react';

const Sidebar = ({ setCollapsed, collapsed }) => {
  const [restaurantId , setRestaurantId] = useState("")
  const { branchId } = useParams();
  
  const getRestaurantId = async () => {
    const resp = await apiMethod.getBranchInfo(branchId);
    if (methods.showApiErrors(resp)){
      setRestaurantId(resp.data.restaurantId)
    }
  }

  useEffect(() => {
    getRestaurantId()
  } , [])

  const toggleSidebar = () => {
    setCollapsed(!collapsed);
  };

  const renderSidebar = () => {
    return (
      <>
        <div className="offcanvas-lg offcanvas-start" tabIndex="-1" id="sidebarMenu" aria-labelledby="sidebarMenuLabel">
          <div className="offcanvas-header">
            <p className="offcanvas-title" id="sidebarMenuLabel"></p>
            <button type="button" className="btn-close" data-bs-dismiss="offcanvas" data-bs-target="#sidebarMenu" aria-label="Close"></button>
          </div>
          <div className={`offcanvas-body d-lg-flex flex-column p-0 pt-4 overflow-y-auto${collapsed ? ' text-center' : ''}`}>
            <div className="d-none d-lg-flex justify-content-end ">
              <span className='toggleImg' onClick={toggleSidebar}>
                {collapsed ? <i className="bi bi-arrow-left-circle fs-5"></i> : <i className="bi bi-arrow-right-circle fs-5"></i>}
              </span>
            </div>
            {!collapsed ?
              <ul className='list-group list-group-flush'>
                <Link to={`/${restaurantId}/dashboard`} className='link'>
                  <li className="list-group-item d-flex justify-content-between align-items-center px-2 py-3 border-top-0">
                    <div className='text-truncate'>
                      <img src={shop} alt="shop" />
                      <span className="pe-1">
                        شعبه‌های رستوران
                      </span>
                    </div>
                    <div>
                      <span className="badge sidebar-badge rounded-pill"></span>
                      <span className="">
                        <img src={arrowLeftSide} alt="arrowLeft" />
                      </span>
                    </div>
                  </li>
                </Link>
                <Link to={`/accounting/${branchId}`} className='link'>
                  <li className="list-group-item d-flex justify-content-between align-items-center px-2 py-3">
                    <div>
                      <img src={calculator} alt="calculator" />
                      <span className="pe-1">
                        حسابداری
                      </span>
                    </div>
                    <div>
                      <span className="badge sidebar-badge rounded-pill"></span>
                      <span className="">
                        <img src={send} alt="arrowLeft" />
                      </span>
                    </div>
                  </li>
                </Link>
                <Link to={`/warehouse/${restaurantId}/${branchId}`} className='link'>
                  <li className="list-group-item d-flex justify-content-between align-items-center px-2 py-3">
                    <div>
                      <img src={home} alt="home" />
                      <span className="pe-1">
                        انبار
                      </span>
                    </div>
                    <div>
                      <span className="badge sidebar-badge rounded-pill"></span>
                      <span className="">
                        <img src={send} alt="arrowLeft" />
                      </span>
                    </div>
                  </li>
                </Link>
                <Link to={`/sale/${branchId}/reports/home`} className='link'>
                  <li className="list-group-item d-flex justify-content-between align-items-center px-2 py-3">
                    <div>
                      <img src={document} alt="document" />
                      <span className="pe-1">
                        گزارش‌ها
                      </span>
                    </div>
                    <div>
                      <span className="badge sidebar-badge rounded-pill"></span>
                      <span className="">
                        <img src={arrowLeftSide} alt="arrowLeft" />
                      </span>
                    </div>
                  </li>
                </Link>
                <Link to={`/sale/${branchId}/support/invoices`} className='link'>
                  <li className="list-group-item d-flex justify-content-between align-items-center px-2 py-3">
                    <div>
                      <img src={document} alt="document" />
                      <span className="pe-1">
                        پشتیبانی
                      </span>
                    </div>
                    <div>
                      <span className="badge sidebar-badge rounded-pill"></span>
                      <span className="">
                        <img src={arrowLeftSide} alt="arrowLeft" />
                      </span>
                    </div>
                  </li>
                </Link>
                <Link to={'/baseinfo/' + branchId} className='link'>
                  <li className="list-group-item d-flex justify-content-between align-items-center px-2 py-3">
                    <div>
                      <i className="bi bi-info-circle fs-5"></i>
                      <span className="pe-1">
                        اطلاعات عمومی
                      </span>
                    </div>
                    <div>
                      <span className="">
                        <img src={arrowLeftSide} alt="arrowLeft" />
                      </span>
                    </div>
                  </li>
                </Link>
                <Link to="/notification" className='link'>
                  <li className="list-group-item d-flex justify-content-between align-items-center px-2 py-3">
                    <div>
                      <img src={notification} alt="notification" />
                      <span className="pe-1">
                        پیام‌ها
                      </span>
                    </div>
                    <div>
                      <span className="badge sidebar-badge rounded-pill"></span>
                      <span className="">
                        <img src={arrowLeftSide} alt="arrowLeft" />
                      </span>
                    </div>
                  </li>
                </Link>
                <Link to={`/sale/${branchId}/softwareGuide`} className='link'>
                  <li className="list-group-item d-flex justify-content-between align-items-center px-2 py-3">
                    <div>
                      <i className="bi bi-journal-text fs-5"></i>
                      <span className="pe-1">
                        راهنمای نرم‌افزار
                      </span>
                    </div>
                    <div>
                      <span className="badge sidebar-badge rounded-pill"></span>
                      <span className="">
                        <img src={arrowLeftSide} alt="arrowLeft" />
                      </span>
                    </div>
                  </li>
                </Link>
              </ul>
              :
              <ul className="list-group text-center">
                <Link to="/dashboard" className='link'>
                  <li className="list-group-item">
                    <img src={shop} alt="shop" />
                  </li>
                </Link>
                <Link to="/accounting" className='link'>
                  <li className="list-group-item">
                    <img src={calculator} alt="calculator" />
                  </li>
                </Link>
                <Link to="/warehouse" className='link'>
                  <li className="list-group-item">
                    <img src={home} alt="home" />
                  </li>
                </Link>
                <Link to="/reports" className='link'>
                  <li className="list-group-item">
                    <img src={document} alt="document" />
                  </li>
                </Link >
                <Link to="/reports" className='link'>
                  <li className="list-group-item">
                    <i className="bi bi-info-circle fs-5"></i>
                  </li>
                </Link >
                <Link to="/notification" className='link'>
                  <li className="list-group-item">
                    <img src={notification} alt="notification" />
                  </li>
                </Link >
                <Link to={`/sale/${branchId}/softwareGuide`} className='link'>
                  <li className="list-group-item">
                    <i className="bi bi-journal-text fs-5"></i>
                  </li>
                </Link >
              </ul>
            }
          </div >
        </div >
      </>
    );
  };

  return (
    <>
      {renderSidebar()}
    </>
  );
}

export default Sidebar;